import { Components, Theme } from '@mui/material';

export const MuiDialogActions: Components<
  Omit<Theme, 'components'>
>['MuiDialogActions'] = {
  styleOverrides: {
    root: {
      padding: '0 25px 30px 0',
    },
  },
};
